import { TileEntrySubmission } from "../../models/app/Tile";


export const MOCK_ATTENDANCE: TileEntrySubmission[] = [
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "41149744",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "38152009",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "31665008",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "28624178",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "96955357",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "48470625",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "55571292",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "41803722",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "76262947",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "52682411",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "81888190",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "20936679",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "32324131",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "43754947",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "74114284",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "35251913",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "20380320",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "74886921",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 8
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "41149744",
    "grade": "0",
    "entry_id": 9
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "38152009",
    "grade": "0",
    "entry_id": 9
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "31665008",
    "grade": "0",
    "entry_id": 9
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 9
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "96955357",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "48470625",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "55571292",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "41803722",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "76262947",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "52682411",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "81888190",
    "grade": "0",
    "entry_id": 9
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "20936679",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "32324131",
    "grade": "0",
    "entry_id": 9
  },
  {
    "userID": "43754947",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "74114284",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "35251913",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "20380320",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "48905367",
    "grade": "0",
    "entry_id": 9
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "74886921",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 9
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "41149744",
    "grade": "0",
    "entry_id": 10
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "38152009",
    "grade": "0",
    "entry_id": 10
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "31665008",
    "grade": "0",
    "entry_id": 10
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 10
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "96955357",
    "grade": "0",
    "entry_id": 10
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "48470625",
    "grade": "0",
    "entry_id": 10
  },
  {
    "userID": "54264654",
    "grade": "0",
    "entry_id": 10
  },
  {
    "userID": "55571292",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "41803722",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "76262947",
    "grade": "0",
    "entry_id": 10
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "52682411",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "81888190",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "20936679",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "32324131",
    "grade": "0",
    "entry_id": 10
  },
  {
    "userID": "43754947",
    "grade": "0",
    "entry_id": 10
  },
  {
    "userID": "18298956",
    "grade": "0",
    "entry_id": 10
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "74114284",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "35251913",
    "grade": "0",
    "entry_id": 10
  },
  {
    "userID": "20380320",
    "grade": "0",
    "entry_id": 10
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "96600883",
    "grade": "0",
    "entry_id": 10
  },
  {
    "userID": "74886921",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 10
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "41149744",
    "grade": "0",
    "entry_id": 11
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "38152009",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "28332183",
    "grade": "0",
    "entry_id": 11
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "31665008",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 11
  },
  {
    "userID": "81005245",
    "grade": "0",
    "entry_id": 11
  },
  {
    "userID": "86899376",
    "grade": "0",
    "entry_id": 11
  },
  {
    "userID": "96955357",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "48470625",
    "grade": "0",
    "entry_id": 11
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "55571292",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "41803722",
    "grade": "0",
    "entry_id": 11
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "76262947",
    "grade": "0",
    "entry_id": 11
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "52682411",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "81888190",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "20936679",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "32324131",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "43754947",
    "grade": "0",
    "entry_id": 11
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "74114284",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "35251913",
    "grade": "0",
    "entry_id": 11
  },
  {
    "userID": "20380320",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "48905367",
    "grade": "0",
    "entry_id": 11
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "96600883",
    "grade": "0",
    "entry_id": 11
  },
  {
    "userID": "74886921",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 11
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "22976781",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "41149744",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "27034712",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "23744275",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "38152009",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "31665008",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "96955357",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "48470625",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "54264654",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "55571292",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "41803722",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "46666218",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "76262947",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "43219917",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "52682411",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "81888190",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "20936679",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "32324131",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "43754947",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "77161172",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "74114284",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "66889858",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "35251913",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "20380320",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "74886921",
    "grade": "0",
    "entry_id": 12
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 12
  },
  {
    "userID": "41393783",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "24585559",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "22976781",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "41149744",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "27034712",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "23744275",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "38152009",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "31665008",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "81005245",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "96955357",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "48470625",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "55571292",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "41803722",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "46666218",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "76262947",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "43219917",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "52682411",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "81888190",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "20936679",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "32324131",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "43754947",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "18298956",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "77161172",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "74114284",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "46647543",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "35251913",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "20380320",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "74886921",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "95366984",
    "grade": "0",
    "entry_id": 13
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 13
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "41149744",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "38152009",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "31665008",
    "grade": "0",
    "entry_id": 14
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "28624178",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "96955357",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "48470625",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "55571292",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "41803722",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "76262947",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "52682411",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "81888190",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "20936679",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "32324131",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "43754947",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "74114284",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "35251913",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "20380320",
    "grade": "0",
    "entry_id": 14
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "74886921",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 14
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "41149744",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "27034712",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "38152009",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "55249485",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "31665008",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "81005245",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "86899376",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "96955357",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "48470625",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "55571292",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "97222205",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "41803722",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "41898388",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "76262947",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "52682411",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "45476233",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "81888190",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "20936679",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "32324131",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "43754947",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "74114284",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "35251913",
    "grade": "0",
    "entry_id": 15
  },
  {
    "userID": "20380320",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "74886921",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 15
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "41149744",
    "grade": "0",
    "entry_id": 16
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "38152009",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "55249485",
    "grade": "0",
    "entry_id": 16
  },
  {
    "userID": "31665008",
    "grade": "0",
    "entry_id": 16
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 16
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "96955357",
    "grade": "0",
    "entry_id": 16
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "48470625",
    "grade": "0",
    "entry_id": 16
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "55571292",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "27817769",
    "grade": "0",
    "entry_id": 16
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "41803722",
    "grade": "0",
    "entry_id": 16
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "76262947",
    "grade": "0",
    "entry_id": 16
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "52682411",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "81888190",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "50326251",
    "grade": "0",
    "entry_id": 16
  },
  {
    "userID": "20936679",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "32324131",
    "grade": "0",
    "entry_id": 16
  },
  {
    "userID": "43754947",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "74114284",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "35683215",
    "grade": "0",
    "entry_id": 16
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "35251913",
    "grade": "0",
    "entry_id": 16
  },
  {
    "userID": "20380320",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "74886921",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 16
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "41149744",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "38152009",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "31665008",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "86899376",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "96955357",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "48470625",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "55571292",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "27817769",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "41803722",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "76262947",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "52682411",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "81888190",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "50326251",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "20936679",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "32324131",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "43754947",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "77161172",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "74114284",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "35683215",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "66889858",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "35251913",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "20380320",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "74886921",
    "grade": "0",
    "entry_id": 17
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 17
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "41149744",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "38152009",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "28332183",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "31665008",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "59540503",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "96955357",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "48470625",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "55571292",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "97222205",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "41803722",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "76262947",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "43219917",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "52682411",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "81888190",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "50326251",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "20936679",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "32324131",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "43754947",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "74114284",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "35683215",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "35251913",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "20380320",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "74886921",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "95366984",
    "grade": "0",
    "entry_id": 18
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 18
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "41149744",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "38152009",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "31665008",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "28624178",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "96955357",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "48470625",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "55571292",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "41803722",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "76262947",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "52682411",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "81888190",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "20936679",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "32324131",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "43754947",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "74114284",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "35251913",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "20380320",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "74886921",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 19
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "41149744",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "23744275",
    "grade": "0",
    "entry_id": 20
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "38152009",
    "grade": "0",
    "entry_id": 20
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "28332183",
    "grade": "0",
    "entry_id": 20
  },
  {
    "userID": "55249485",
    "grade": "0",
    "entry_id": 20
  },
  {
    "userID": "31665008",
    "grade": "0",
    "entry_id": 20
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 20
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "96955357",
    "grade": "0",
    "entry_id": 20
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "48470625",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "55571292",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "41803722",
    "grade": "0",
    "entry_id": 20
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "76262947",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "52682411",
    "grade": "0",
    "entry_id": 20
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "81888190",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "50326251",
    "grade": "0",
    "entry_id": 20
  },
  {
    "userID": "20936679",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "32324131",
    "grade": "0",
    "entry_id": 20
  },
  {
    "userID": "43754947",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "74114284",
    "grade": "0",
    "entry_id": 20
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "35251913",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "20380320",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "74886921",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "95366984",
    "grade": "0",
    "entry_id": 20
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 20
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "41149744",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "38152009",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "28332183",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "31665008",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "96955357",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "48470625",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "55571292",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "95372011",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "41803722",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "46666218",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "76262947",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "52682411",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "81888190",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "20936679",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "32324131",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "43754947",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "77161172",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "74114284",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "35251913",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "20380320",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "96600883",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "74886921",
    "grade": "0",
    "entry_id": 21
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 21
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "41149744",
    "grade": "0",
    "entry_id": 22
  },
  {
    "userID": "27034712",
    "grade": "0",
    "entry_id": 22
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "38152009",
    "grade": "0",
    "entry_id": 22
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "31665008",
    "grade": "0",
    "entry_id": 22
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 22
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "96955357",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "48470625",
    "grade": "0",
    "entry_id": 22
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "55571292",
    "grade": "0",
    "entry_id": 22
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "41803722",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "76262947",
    "grade": "0",
    "entry_id": 22
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "52682411",
    "grade": "0",
    "entry_id": 22
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "81888190",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "20936679",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "32324131",
    "grade": "0",
    "entry_id": 22
  },
  {
    "userID": "43754947",
    "grade": "0",
    "entry_id": 22
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "74114284",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "35683215",
    "grade": "0",
    "entry_id": 22
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "35251913",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "20380320",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "74886921",
    "grade": "0",
    "entry_id": 22
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 22
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "41149744",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "38152009",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "31665008",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "28624178",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "96955357",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "48470625",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "55571292",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "41803722",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "76262947",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "52682411",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "81888190",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "20936679",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "32324131",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "43754947",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "74114284",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "35251913",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "20380320",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "74886921",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 23
  },
  {
    "userID": "41393783",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "41149744",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "23744275",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "38152009",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "31665008",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "96955357",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "48470625",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "55571292",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "97222205",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "41803722",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "76262947",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "43219917",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "52682411",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "81888190",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "20936679",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "32324131",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "43754947",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "77161172",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "74114284",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "46647543",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "35251913",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "20380320",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "96600883",
    "grade": "0",
    "entry_id": 24
  },
  {
    "userID": "74886921",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 24
  },
  {
    "userID": "41393783",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "41149744",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "27034712",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "38152009",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "28332183",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "31665008",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "81005245",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "96955357",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "48470625",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "55571292",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "97222205",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "41803722",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "76262947",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "52682411",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "45476233",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "81888190",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "20936679",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "32324131",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "43754947",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "18298956",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "77161172",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "74114284",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "42345728",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "46647543",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "66889858",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "35251913",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "20380320",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "96600883",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "74886921",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "95366984",
    "grade": "0",
    "entry_id": 25
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 25
  },
  {
    "userID": "41393783",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "41149744",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "27034712",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "16967126",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "38152009",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "31665008",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "96955357",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "48470625",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "55571292",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "27817769",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "95372011",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "97222205",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "41803722",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "76262947",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "43219917",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "52682411",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "81888190",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "20936679",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "32324131",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "43754947",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "18298956",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "74114284",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "35683215",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "42345728",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "70805720",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "66889858",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "35251913",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "20380320",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "96600883",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "74886921",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "95366984",
    "grade": "0",
    "entry_id": 26
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 26
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "41149744",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "38152009",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "31665008",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "28624178",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "96955357",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "48470625",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "55571292",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "97222205",
    "grade": "0",
    "entry_id": 27
  },
  {
    "userID": "41803722",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "76262947",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "52682411",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "81888190",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "20936679",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "32324131",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "43754947",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "74114284",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "35251913",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "20380320",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "74886921",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 27
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "41149744",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "38152009",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "31665008",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "28624178",
    "grade": "0",
    "entry_id": 28
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "96955357",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "90434281",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "48470625",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "55571292",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "41803722",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "76262947",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "52682411",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "81888190",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "20936679",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "32324131",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "43754947",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "74114284",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "35251913",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "20380320",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "74886921",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 28
  },
  {
    "userID": "41393783",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "24585559",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "22976781",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "41149744",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "27034712",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "23744275",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "16967126",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "38152009",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "21276717",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "23400528",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "28332183",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "55249485",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "31665008",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "59540503",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "28624178",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "81005245",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "86899376",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "96955357",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "90434281",
    "grade": "0",
    "entry_id": 29
  },
  {
    "userID": "48470625",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "54264654",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "55571292",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "27817769",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "95372011",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "97222205",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "41803722",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "46666218",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "41898388",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "76262947",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "43219917",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "52682411",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "45476233",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "81888190",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "50326251",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "20936679",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "32324131",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "43754947",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "18298956",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "77161172",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "74114284",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "35683215",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "42345728",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "70805720",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "46647543",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "66889858",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "35251913",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "20380320",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "45844627",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "48905367",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "29376337",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "96600883",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "74886921",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "95366984",
    "grade": "1",
    "entry_id": 29
  },
  {
    "userID": "53036575",
    "grade": "1",
    "entry_id": 29
  }
]
